/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceQuoteLineRequest
 */
export interface FixedPriceQuoteLineRequest {
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteLineRequest
     */
    lineId?: string;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteLineRequest
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteLineRequest
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteLineRequest
     */
    unitPriceExcludingTaxes: number;
}

/**
 * Check if a given object implements the FixedPriceQuoteLineRequest interface.
 */
export function instanceOfFixedPriceQuoteLineRequest(value: object): value is FixedPriceQuoteLineRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    return true;
}

export function FixedPriceQuoteLineRequestFromJSON(json: any): FixedPriceQuoteLineRequest {
    return FixedPriceQuoteLineRequestFromJSONTyped(json, false);
}

export function FixedPriceQuoteLineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteLineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
    };
}

export function FixedPriceQuoteLineRequestToJSON(value?: FixedPriceQuoteLineRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lineId': value['lineId'],
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
    };
}

